"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function BillingGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#6C757D",
    clipPath: "url(#prefix__billing-grey-outline__clip0_13467_341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.425 10.008h-.188a.599.599 0 01-.602-.597c0-.33.269-.597.602-.597h.192c.333 0 .602.266.602.597 0 .33-.273.597-.606.597zM10.572 13.012H3.57a.599.599 0 01-.602-.597c0-.33.269-.597.602-.597h6.997c.333 0 .602.267.602.597 0 .33-.265.597-.598.597zM12.425 13.012h-.188a.599.599 0 01-.602-.597c0-.33.269-.597.602-.597h.192c.333 0 .602.267.602.597 0 .33-.273.597-.606.597zM10.572 10.008H3.57a.599.599 0 01-.602-.597c0-.33.269-.597.602-.597h6.997c.333 0 .602.266.602.597 0 .33-.265.597-.598.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.997 16H1.003A1 1 0 010 15.005V.752c0-.29.18-.55.453-.66a.75.75 0 01.823.17l1.14 1.178L3.522.302A1.03 1.03 0 014.237 0h.008c.269 0 .517.103.71.29l1.167 1.162L7.262.298c.196-.19.45-.298.722-.298.273 0 .526.107.718.298l1.132 1.146 1.139-1.15a.992.992 0 01.71-.294 1 1 0 01.718.302l1.128 1.146 1.2-1.201a.75.75 0 01.818-.163c.272.111.449.37.449.656v14.257A.997.997 0 0114.997 16zM1.204 14.806h13.592V1.878l-.553.557a.992.992 0 01-.714.295h-.004a.984.984 0 01-.715-.303l-1.127-1.146-1.14 1.15a1.012 1.012 0 01-1.432 0l-1.127-1.15-1.14 1.15a.994.994 0 01-.71.299 1.04 1.04 0 01-.714-.29L4.253 1.28 3.14 2.42a1.006 1.006 0 01-1.444-.004l-.493-.505v12.896z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.572 7.007H3.57a.599.599 0 01-.602-.597c0-.33.269-.597.602-.597h6.997c.333 0 .602.267.602.597 0 .33-.265.597-.598.597zM12.425 7.007h-.188a.599.599 0 01-.602-.597c0-.33.269-.597.602-.597h.192c.333 0 .602.267.602.597 0 .33-.273.597-.606.597z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__billing-grey-outline__clip0_13467_341"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

BillingGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
BillingGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = BillingGreyOutline;
exports["default"] = _default;